module.exports = __webpack_public_path__ + "media/images/front/brands/signature/signature_header_2_m-db8152739a2d645468b965e08ed10a77.jpg";